module.exports = __webpack_public_path__ + "img/des-main-background-420.9b7bd803.jpeg";